import axios from 'axios';

// Create axios instance with default config
const api = axios.create({
  baseURL: process.env.REACT_APP_EXPRESS_URL,
  headers: {
    'Content-Type': 'application/json',
    Platform: 'web',
  },
});

// Paths that don't require authentication
const noAuthPaths = [
  '/api/users/login',
  '/api/users/reset',
  '/api/canCare/signupFromPortal',
  '/api/canCare/resendOtp',
  '/api/canCare/verifyOtp',
  '/api/canCare/signupByInvite',
  '/api/canCare/getTokenData',
];

// Request interceptor
api.interceptors.request.use((config) => {
  const isNoAuthPath = noAuthPaths.some((path) => config.url.includes(path));
  config.headers.Platform = 'web';

  if (!isNoAuthPath) {
    const token = localStorage.getItem('auth') || sessionStorage.getItem('token');
    if (token) {
      config.headers.authorization = token;
    }
  }

  return config;
});

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Handle common errors
    if (error.response?.status === 401) {
      // Handle unauthorized - maybe redirect to login
      //   window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export default api;
